import React, { useState } from 'react';
import CommentModal from './CommentModal';

export default function CommentButton({ transactionId, transactionDescription, transactionAmount, transactionType = 'CREDITCARD', hasComments: initialHasComments = false }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [hasComments, setHasComments] = useState(initialHasComments);
    
    return (
        <>
            <button
                onClick={() => setIsModalOpen(true)}
                style={{
                    position: 'relative',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    transition: 'all 0.2s',
                    width: '28px',
                    height: '28px',
                    margin: 0
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F5F5F5'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                title={hasComments ? 'יש הערות' : 'הוסף הערה'}
            >
                <span style={{
                    fontSize: '24px',
                    lineHeight: '28px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    filter: hasComments ? 'none' : 'grayscale(100%) opacity(0.5)'
                }}>💬</span>
                
                {/* Larger blue dot indicator */}
                {hasComments && (
                    <span style={{
                        position: 'absolute',
                        top: '-3px',
                        right: '-3px',
                        backgroundColor: '#2196F3',
                        borderRadius: '50%',
                        width: '14px',
                        height: '14px',
                        border: '2.5px solid white',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
                    }} />
                )}
            </button>
            
            <CommentModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                transactionId={transactionId}
                transactionType={transactionType}
                transactionDescription={transactionDescription}
                transactionAmount={transactionAmount}
                onCommentsChange={(count) => setHasComments(count > 0)}
            />
        </>
    );
}